module.exports = "/images/gw.svg?59ccbc230ca3133fdcf5141adaa3548f";